import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast1 extends BCComponent {

    render() {
        return (
            <div>
                <h1>FINANČNĚ GRAMOTNÝ ČLOVĚK</h1>
                <p className='separate-bottom'>Finančně gramotný člověk má schopnosti, které mu umožňují rozumět penězům a správně s nimi zacházet tak, aby žil spokojený život podle svých představ a plnil si své sny a cíle.</p>

                {this.showTask("zs_fin_1")}
                {this.showTask("zs_fin_2")}
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast1);
